export enum ToastAppType {
    Web = 'web',
    Native = 'native'
}
